import fetch from '../../../core/fetch';
import showToaster from '../../../helpers/showToaster';
import { updateBannerSettings } from '../../../lib/graphql';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: updateBannerSettings,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  const result = data?.updateBannerSettings?.status

  showToaster({
    messageId: result === "success" ? 'bannerSetting' : 'bannerSettingError',
    toasterType: result === "success" ? 'success' : 'error'
  })

}

export default submit;